<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7812 15.6289C17.0547 15.9023 17.0547 16.3125 16.7812 16.5586C16.6719 16.6953 16.5078 16.75 16.3438 16.75C16.1523 16.75 15.9883 16.6953 15.8789 16.5586L12.2148 12.8945C11.2305 13.6875 10 14.125 8.6875 14.125C5.54297 14.125 3 11.582 3 8.4375C3 5.32031 5.54297 2.75 8.6875 2.75C11.8047 2.75 14.375 5.32031 14.375 8.4375C14.375 9.77734 13.9102 11.0078 13.1172 11.9648L16.7812 15.6289ZM8.6875 12.8125C11.0938 12.8125 13.0625 10.8711 13.0625 8.4375C13.0625 6.03125 11.0938 4.0625 8.6875 4.0625C6.25391 4.0625 4.3125 6.03125 4.3125 8.4375C4.3125 10.8711 6.25391 12.8125 8.6875 12.8125ZM10.875 7.78125C11.2305 7.78125 11.5312 8.08203 11.5312 8.4375C11.5312 8.82031 11.2305 9.09375 10.8203 9.09375H9.28906V10.625C9.28906 11.0078 9.01562 11.2812 8.66016 11.2812C8.30469 11.2812 8.03125 11.0078 8.03125 10.625V9.09375H6.47266C6.11719 9.09375 5.84375 8.82031 5.84375 8.4375C5.84375 8.08203 6.11719 7.78125 6.47266 7.78125H8.03125V6.25C8.03125 5.89453 8.33203 5.59375 8.6875 5.59375C9.01562 5.59375 9.31641 5.89453 9.31641 6.25V7.78125H10.875Z"
      fill="currentColor"
    />
  </svg>
</template>
